module.exports = __webpack_public_path__ + "static/img/content5.f49f8e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mo/zh/content5.png
// module id = +PeX
// module chunks = 1 3